import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type UiState = {
  /** Icon-only sidebar rail. A per-device display preference, toggled from the sidebar user menu. */
  isSidebarCollapsed: boolean;
};

const SIDEBAR_COLLAPSED_STORAGE_KEY = "sidebar_collapsed";

function loadPersisted(): UiState {
  try {
    return { isSidebarCollapsed: localStorage.getItem(SIDEBAR_COLLAPSED_STORAGE_KEY) === "true" };
  } catch {
    return { isSidebarCollapsed: false };
  }
}

const initialState: UiState = loadPersisted();

const slice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setSidebarCollapsed(state, action: PayloadAction<boolean>) {
      state.isSidebarCollapsed = action.payload;
      localStorage.setItem(SIDEBAR_COLLAPSED_STORAGE_KEY, String(action.payload));
    },
  },
});

export const { setSidebarCollapsed } = slice.actions;
export const uiReducer = slice.reducer;
